import { connect } from 'react-redux'
import GigStatus from './GigStatus'

const mapStateToProps = state => {

  const webcast = state.webcast.collection[`${state.config.channelId}${state.config.webcastId}`]
  return {
    status: state.ui.status,
    date: webcast && webcast.status.hasData && webcast.data.start,
    duration: webcast && webcast.status.hasData && webcast.data.duration
  }

}

export default connect(mapStateToProps)(GigStatus)
